import { render, staticRenderFns } from "./profileAdapter.vue?vue&type=template&id=2c3def8c&scoped=true"
import script from "./profileAdapter.vue?vue&type=script&lang=js"
export * from "./profileAdapter.vue?vue&type=script&lang=js"
import style0 from "./profileAdapter.vue?vue&type=style&index=0&id=2c3def8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3def8c",
  null
  
)

export default component.exports